export const branchName = process.env.CONTENTFUL_ENVIRONMENT_ID || "master";

export const preview = false;

export const entryIds = {
  footer: "78493B7i5B8sULKtn42IlE",
  stickyFooter: "6aT86JH4iFq956a658LCBf"
};

export const contentIds = {
  featuredBlogPost: "featuredBlogPosts",
  blogCategory: "blogCategory"
};
